import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Success, Error } from "../ui/toaster";
import generateAction from "../../utils/action-helpers";
import { MESSAGES } from "../../state/actions";
import { messageState } from "../../utils/messajes";

const Messages = React.memo(() => {
  const dispatch = useDispatch();
  const { proposalStatus, deleteStatus } = useSelector(state => state.messages);
  const [messageSuccess, setMessageSuccess] = useState(proposalStatus === messageState.SUCCESS);
  const [deleteSuccess, setDeleteSuccess] = useState(deleteStatus === messageState.SUCCESS);
  const [deleteError, setDeleteError] = useState(deleteStatus === messageState.ERROR);
  useEffect(() => {
    setMessageSuccess(proposalStatus === messageState.SUCCESS);
  }, [proposalStatus]);
  useEffect(() => {
    setDeleteError(deleteStatus === messageState.ERROR);
    setDeleteSuccess(deleteStatus === messageState.SUCCESS);
  }, [deleteStatus]);

  const updateProposalStatus = () =>
    dispatch(generateAction(MESSAGES.PROPOSAL_STATUS, messageState.IDLE));
  const updateDeleteStatus = () =>
    dispatch(generateAction(MESSAGES.DELETE_STATUS, messageState.IDLE));

  return (
    <div>
      <Success
        id="proposal_success"
        visible={messageSuccess}
        title="La transferencia se ha conciliado con éxito."
        text={`Puede visualizarla en la pestaña de "Conciliadas".`}
        onClose={updateProposalStatus}
      />
      <Error
        id="delete_error"
        visible={deleteError}
        title="Error al eliminar la transferencia"
        text="Se ha producido un error al eliminar la transferencia."
        onClose={updateDeleteStatus}
      />
      <Success
        id="delete_success"
        visible={deleteSuccess}
        title="Transferencia eliminada"
        text="Se eliminado con exito la transferencia."
        onClose={updateDeleteStatus}
      />
    </div>
  );
});

export default Messages;
